import { IconBase, IconProps } from './Base'

export const IconArrowUp = (props: IconProps) => (
  <IconBase width={props.width || 16} height={props.height || 16} viewBox="0 0 16 16" fill="none">
    <path
      d="M12 10L8 6L4 10"
      stroke={props.stroke || '#16C784'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
